import React from "react";
import { apiEndpoint } from "helpers/url_helper";

import { render } from "react-dom";
// Import Highcharts
import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts/highstock';
import exportingModule from "highcharts/modules/exporting"
exportingModule(Highcharts)
require("highcharts/modules/export-data.js")(Highcharts);
class MaxSpeedChart extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          maxSpeed: [],
        }
   
    this.afterChartCreated = this.afterChartCreated.bind(this);
      
    this.state = {
      chartOptions: {
        chart: {
          type: "column",
        },
        title: {
          text: ""
        },
        credits: {
            enabled: false
        },
        yAxis: {
            title: {
              text: "Speed"
            }
          },
        xAxis: {
            labels: {
              format: "{value:%b %e}" 
            },
            type: "datetime",
          },
        
        rangeSelector: {
          selected: 6,
          
      },
        series: [
          {    step: true,
            name: "Maximum Speed",
            data: this.state.maxSpeed,        
           color: "#6082B6",
            borderRadius:5,   
            dataGrouping: {
              enabled: false
            }
          },
          
        ],
        // exporting: {
        // showTable: false
        // },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "viewFullscreen",
                       "printChart",
                          "separator",
                          "downloadPNG",
                          "downloadJPEG",
                          "downloadPDF",
                          "downloadSVG",
                          "separator",
                          "downloadCSV",
                          "downloadXLS",
                          //"viewData",
                         ]
            }
          },        
          filename:"Maximum Speed_"+new Date().toLocaleDateString(),
          
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 2000
              }
            }
          ]
        }
      }
    };
  }

  afterChartCreated(chart) {
 if (!chart.options.chart.forExport) {
    this.internalChart = chart;
    // this.internalChart.rangeSelector={
    //   selected: 6
    // },
    this.forceUpdate();
  }
       
  }

 async componentDidUpdate(prevProps) {
   if(prevProps.props!=this.props.props){
    // can't change
    const response = await fetch(apiEndpoint+"/VehicleCountGetMaxSpeedData", {
      
    method: 'POST',
    headers: {
        'Content-Type': 'application/json', 
    },
    body:this.props.props
  });
    console.log(response);
   if(response.body!=null && response !=undefined)
   {
  const data = await response.json();
  var objToArr=JSON.parse( data.maxSpeed);
  const newArrayOfObj = (objToArr).map(({
    "Key": x,
    "Value":y,
    ...rest
  }) => ({
    x,y,
    ...rest
  }));
  this.setState({maxSpeed:newArrayOfObj})
  if(this.internalChart.series!=undefined){
  this.internalChart.series[0].setData(newArrayOfObj);
  }
   }
   }
    
  }

  async UNSAFE_componentWillReceiveProps (props) {
    console.log(props.props)
    if(props.props!=undefined){
      console.log(props.props)
      console.log(this.props.props)
    // can't change
    const response = await fetch(apiEndpoint+"/VehicleCountGetMaxSpeedData", {
      
        method: 'POST',
        headers: {
            'Content-Type': 'application/json', 
        },
        body:props.props
      });
        console.log(response);
       if(response.body!=null && response.body !=undefined)
       {
      const data = await response.json();
      var objToArr=JSON.parse( data.maxSpeed);
      const newArrayOfObj = (objToArr).map(({
        "Key": x,
        "Value":y,
        ...rest
      }) => ({
        x,y,
        ...rest
      }));

      this.setState({maxSpeed:newArrayOfObj})
      if(this.internalChart.series!=undefined){
      this.internalChart.series[0].setData(newArrayOfObj);
      }
    }

  }
    }
   
  render() {
    console.log(this.state.maxSpeed)
    return (
      <HighchartsReact
        style={{ height: "100%" }}
        highcharts={Highcharts}
        options={this.state.chartOptions}
        callback={this.afterChartCreated}
        constructorType={'stockChart'}
       updateArgs={[true]}
   
      />
    );
  }
}

export default MaxSpeedChart;